import { useAuth0 } from "@auth0/auth0-react"
import { useEffect } from "react"
import { baseApi, useGetIotCredsQuery } from "../app/apis/baseApi"
import { useAppDispatch, useAppSelector } from "../app/hooks"
import { setConfig } from "../app/slices/wsSlice"
import { wsService } from "../utils/WebSocketService"

export const useWebSocket = () => {
  const { isAuthenticated } = useAuth0()
  const dispatch = useAppDispatch()

  const { data, isLoading, error, refetch } = useGetIotCredsQuery(undefined, {
    skip: !isAuthenticated,
  })
  const wsConfig = data?.data ?? null
  const wsState = useAppSelector((state) => state.ws)

  useEffect(() => {
    wsService.setDispatch(dispatch)
    wsService.setApi(baseApi)
    wsService.setRefetchConfig(refetch)
  }, [dispatch, refetch])

  // Connect when creds are available, disconnect on unmount.
  // The connect/disconnect are in the SAME effect so StrictMode's
  // unmount→remount cycle correctly reconnects.
  useEffect(() => {
    if (!wsConfig) return

    dispatch(setConfig(wsConfig))
    wsService.connect(wsConfig)

    return () => {
      wsService.disconnect()
    }
  }, [wsConfig, dispatch])

  return {
    wsState,
    isLoading,
    error,
    reconnect: () => wsConfig && wsService.connect(wsConfig),
    disconnect: () => wsService.disconnect(),
  }
}
